'use memo';

import { createFileRoute } from '@tanstack/react-router';
import { MyNumberCollectionInstancePage } from '../../../-components/MyNumberCollectionInstancePage';
export const Route = createFileRoute('/_staff/labor-core/_egov-mock/egov-onboarding/my-number-collection/instances/$targetId/')({
  component: MyNumberCollectionInstancePage
});